export default __webpack_public_path__ + "static/kv-logo-jp-03a40c50f931b13848d1df8fcf8ed92d.png";